"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _MotionFlex = _interopRequireDefault(require("../motionComponents/MotionFlex/MotionFlex"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var ProgressBar = function ProgressBar(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary.0" : _ref$color,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? "dark.2" : _ref$bg,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0 : _ref$progress,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "15px" : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1 / 1 : _ref$width,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["color", "bg", "progress", "height", "width", "borderRadius"]);
  return _react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    width: width,
    bg: bg,
    height: height,
    borderRadius: borderRadius
  }, props), _react["default"].createElement(_MotionFlex["default"], (0, _extends2["default"])({
    animate: {
      width: progress + "%"
    },
    transition: {
      ease: "easeInOut"
    },
    height: height,
    bg: color,
    borderRadius: borderRadius
  }, props)));
};

var _default = ProgressBar;
exports["default"] = _default;